var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_Left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01.-Redesigns",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7.1_Customer-Portal-updates-for-Agency-Partner-program",
    transform: "translate(-1120, -246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Pop-Up-Actions-Copy",
    transform: "translate(1100, 54)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-Fill",
    transform: "translate(20, 182)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Left",
    transform: "translate(0, 10)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bounds"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.16666667,2.5 C3.24999998,2.5 2.5,3.24999998 2.5,4.16666667 L2.5,15.8333333 C2.5,16.75 3.24999998,17.5 4.16666667,17.5 L15.8333333,17.5 C16.75,17.5 17.5,16.75 17.5,15.8333333 L17.5,4.16666667 C17.5,3.24999998 16.75,2.5 15.8333333,2.5 L4.16666667,2.5 Z M5.83333333,14.1666667 L5.83333333,8.33333333 L7.5,8.33333333 L7.5,14.1666667 L5.83333333,14.1666667 Z M9.16666667,14.1666667 L9.16666667,5.83333333 L10.8333333,5.83333333 L10.8333333,14.1666667 L9.16666667,14.1666667 Z M12.5,14.1666667 L12.5,10.8333333 L14.1666667,10.8333333 L14.1666667,14.1666667 L12.5,14.1666667 Z",
    id: "path",
    fill: "#8F9BA9",
    mask: "url(#mask-2)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/DashboardIcon.da15bdd63eebfe852ec7ffa98b02c8a1.svg";
export { ForwardRef as ReactComponent };